import { kebabCase } from 'lodash';
import validator from 'validator';

import { sampleAgentNames } from './constants';

export const isValidURL = (urlString: string): boolean => {
  return validator.isURL(urlString);
};

function urlWithProtocol(inputUrl: string): string {
  let url = inputUrl;
  if (!/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }
  return url;
}

export const extractDomain = (urlString: string): string => {
  try {
    const domain = new URL(urlWithProtocol(urlString));
    return domain.hostname;
  } catch (error) {
    return '';
  }
};

export const randomAgentName = () => {
  const randomIndex = Math.floor(Math.random() * sampleAgentNames.length);
  return sampleAgentNames[randomIndex];
};

// A report date range is valid once both bounds are chosen and the start
// is on or before the end. Used to gate the "Email report" CTA and surface
// the inline range error in ExportAgentReportModal.
export const isValidReportDateRange = (
  startDate?: Date,
  endDate?: Date,
): boolean => {
  if (!startDate || !endDate) return false;
  return startDate.getTime() <= endDate.getTime();
};

// Datepicker returns a local calendar date (midnight local time). Serializing it
// directly with toISOString() converts to UTC first, which shifts the calendar day
// for users whose offset pushes local midnight across the UTC date boundary (e.g.
// July 1 becomes June 30 east of UTC). Offset by the timezone difference so the
// selected calendar date is preserved as midnight UTC in the ISO string.
export const toLocalDateISOString = (date: Date): string =>
  new Date(date.getTime() - date.getTimezoneOffset() * 60_000).toISOString();

const pad2 = (value: number): string => String(value).padStart(2, '0');

// [agent-name]-kb-[YYYY-MM-DD-HHMM].csv, falling back to the legacy
// 'knowledge-base.csv' when there's no name to slugify.
export const buildKnowledgeBaseExportFilename = (
  agentName: string,
  date: Date = new Date(),
): string => {
  const slug = kebabCase(agentName);
  if (!slug) return 'knowledge-base.csv';
  const timestamp = `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(
    date.getDate(),
  )}-${pad2(date.getHours())}${pad2(date.getMinutes())}`;
  return `${slug}-kb-${timestamp}.csv`;
};
